import { observable, action, makeObservable } from 'mobx'
import { PREVIEW_CLASS_NAMES } from './constants'

class PreviewModel {
  @observable previewMode = PREVIEW_CLASS_NAMES.DESKTOP
  @action setPreviewMode = (val) => {
    this.previewMode = val
  }

  @observable showPreview = false
  @action setShowPreview = (val) => {
    this.showPreview = val
  }

  @observable showSpinner = true
  @action setShowSpinner = (val) => {
    this.showSpinner = val
  }

  constructor() {
    makeObservable(this)
  }
}

export default new PreviewModel()
